const getCornerRules = (type, shape) => {
  let key = `${type}-${shape}`,
    background = `bg-${key}`,
    boxHeight = 140;

  const smallBoxes = ['N-C', 'P-C', 'R-C', 'F-C', 'I-C', 'G-LLC', 'I-LLC', 'F-LLC', 'N-LLC', 'P-LLC', 'Q-LLC', 'R-LLC', 'F-R', 'M-R', 'N-R', 'F-CR', 'M-CR', 'N-CR', 'F-RF', 'M-RF', 'N-RF', 'F-CRF', 'M-CRF', 'N-CRF', 'F-U', 'I-U', 'I-U', 'N-U', 'R-U', 'F-LS', 'G-LS', 'H-LS', 'I-LS', 'N-LS', 'P-LS', 'Q-LS', 'R-LS'];

  if (smallBoxes.includes(key)) {
    boxHeight = 70;
  }

  let ruleset = {
    'A': {
      cornerA: -1,
      cornerB: -1
    },
    'B': {
      cornerA: 4,
      cornerB: -1
    },
    'C': {
      cornerA: 1,
      cornerB: -1
    },
    'D': {
      cornerA: 3,
      cornerB: -1
    },
    'E': {
      cornerA: 2,
      cornerB: -1
    },
    'F': {
      cornerA: 4,
      cornerB: -1
    },
    'G': {
      cornerA: 3,
      cornerB: -1
    },
    'H': {
      cornerA: 2,
      cornerB: -1
    },
    'I': {
      cornerA: 1,
      cornerB: -1
    },
    'J': {
      cornerA: 1,
      cornerB: 3
    },
    'K': {
      cornerA: 4,
      cornerB: 2
    },
    'L': {
      cornerA: 4,
      cornerB: 3
    },
    'M': {
      cornerA: 1,
      cornerB: 2
    },
    'N': {
      cornerA: 4,
      cornerB: 2
    },
    'P': {
      cornerA: 4,
      cornerB: 3
    },
    'Q': {
      cornerA: 1,
      cornerB: 3
    },
    'R': {
      cornerA: 1,
      cornerB: 2
    }
  }

  return {
    cornerA: ruleset[type].cornerA,
    cornerB: ruleset[type].cornerB,
    boxHeight,
    background
  };
}

export default getCornerRules;